import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';

import SimpleModal from '../../common/components/simple-modal';
import GrowingTextarea from '../../common/components/growing-textarea';
import { valid_email } from "../../../common/utils";
import * as utils from '../../utils';
import * as actions from '../actions';
import store from "../../store";


class RsvpModalForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      validationErrors: {},
    };

    // with the addition of the sms guest, the email may yet have been supplied
    const completeGuest = this.props.guestName && this.props.guestEmail;

    if(!completeGuest || this.props.inviteMethod === 'sms') {
      actions.setIncompleteGuest();
    }
  }

  componentDidMount() {
    if (this.props.showForm && !window.is_mobile_site && !window.is_preview) {
      this.focusCommentInput();
    }
  }
  componentDidUpdate(prevProps) {
    if (!prevProps.showForm && this.props.showForm && !window.is_mobile_site && !window.is_preview) {
      this.focusCommentInput();
    }
  }
  focusCommentInput() {
    if (this.refs.commentInput) {
      ReactDOM.findDOMNode(this.refs.commentInput).focus();
    }
  }
  handleSubmit = (e) => {

    const { totalAdults, totalKids, allowKids} = this.props;
      const totalGuests =
        allowKids? totalKids + totalAdults:
        totalAdults;

    e.preventDefault();
    const rsvpResponse = this.props.rsvpResponse;
    const responseIsPositive = ['yes', 'maybe'].includes(rsvpResponse);

    if (this.props.showPlusOneOptions && responseIsPositive && totalGuests > 1) {
      // capture the email address entered in the plus ones email entry
      // widget if there is one before continuing
      if (actions.getPlusOneEditText()) {
        const errMsg = actions.addEmailFromEditorContents(true);
        if (errMsg) {
          setPlusOnesErrorMessage(errMsg);
          return false;
        }
      }
    }

    const formData = {
      topic_id: window.topic_id,
      guest_id: this.props.guestId,
      name: this.props.altGuestName.trim() || this.props.guestName.trim(),
      email: this.props.guestEmail.trim(),
      comments: this.props.comment.trim(),
      optin: this.props.notifyMarketing,
      response: rsvpResponse,
      adults_in_party: this.props.totalAdults,
      kids_in_party: this.props.totalKids,
      is_anonymous: this.props.isAnonymous,
      email_new_comments: this.refs.notificationInputs && this.refs.notificationInputs.state.email_new_comments || false,
      notify_only_my_activity: this.refs.notificationInputs && this.refs.notificationInputs.state.notify_only_my_activity || false,
    };

    if (!formData.name) {
      this.setState({
        validationErrors: {
          guestName: 'Please enter a name',
        },
      });
      return false;
    }

    if (this.props.editingName && !this.props.altGuestName.trim() && !formData.name) {
      this.setState({
        validationErrors: {
          guestName: 'Please enter a name',
        },
      });
      return false;
    }

    if (!valid_email(formData.email).is_valid) {
      this.setState({
        validationErrors: {
          guestEmail: 'Enter valid email',
        },
      });
      return false;
    }

    const plusOneEmails = actions.getPlusOneEmails();
    if (formData.email && plusOneEmails.includes(formData.email)) {
      setPlusOnesErrorMessage(actions.getPlusOneAlreadyOnGuestListMessageFor(formData.email));
      return false;
    }

    if (formData.adults_in_party < 0) {
      this.setState({
        validationErrors: {
          totalAdults: 'Enter valid number',
        },
      });
      return false;
    }

    if (formData.kids_in_party < 0) {
      this.setState({
        validationErrors: {
          totalKids: 'Enter valid number',
        },
      });
      return false;
    }

    if (this.props.showPlusOneOptions && responseIsPositive) {
      formData.plus_one_emails = actions.getPlusOneEmailsStr();
    }
    actions.submitRsvp(formData);
    return false;
  };

  handleCommentChange = (e) => {
    actions.setRsvpComment(e.target.value);
  };

  closeModal = () => {
    actions.toggleRsvpFormVisible();
  };

  render() {
    let content = [];
    if (utils.isCancelled()) {
      content = (
        <h3 className="feed-notice">
          RSVP closed - this event has been canceled
        </h3>
      );
    } else if (utils.eventHasPassed()) {
      content = (
        <h3 className="feed-notice">
          RSVP closed - this event has already occurred
        </h3>
      );
    } else if (utils.isPreview()) {
      content = (
        <h3 className="feed-notice">
          RSVP closed in preview mode
        </h3>
      );
    } else {

      const { totalAdults, totalKids, allowKids } = this.props;
      const totalGuests =
        allowKids? totalKids + totalAdults:
        totalAdults;

      const showPlusOneOptions =
      window.show_plus_ones &&
      this.props.showPlusOneOptions &&
      this.props.rsvpResponse !== "no" &&
      totalGuests > 1;

      content = (
        <div className="rsvp-form-wrap">
          <h1>
            You are RSVPing <span className={this.props.rsvpResponse}>{this.props.rsvpResponse}</span>
          </h1>
          <form onSubmit={this.handleSubmit}>
            { this.props.inGuestlist ?
              <ReplyingAs
                editingName={this.props.editingName}
                guestName={this.props.guestName}
                altGuestName={this.props.altGuestName}
                hasRsvpd={this.props.hasRsvpd}
                validationErrors={this.state.validationErrors}
              />
              :
              <NameEmailInputs
                guestName={this.props.guestName}
                guestEmail={this.props.guestEmail}
                storedGuestName={this.props.storedGuestName}
                storedGuestEmail={this.props.storedGuestEmail}
                formSubmitting={this.props.formSubmitting}
                validationErrors={this.state.validationErrors}
              />
            }
            <fieldset>
              <GrowingTextarea
                textareaValue={this.props.comment}
                handleCommentChange={this.handleCommentChange}
                handleSubmit={this.handleSubmit}
                placeholder="Add a comment..."
                initialRows="2"
                ref="commentInput"
                isDisabled={this.props.formSubmitting}
              />
            </fieldset>
            { this.props.allowGuests && this.props.promptForGuestCount && this.props.rsvpResponse !== 'no' &&
              <TotalGuests
                totalAdults={this.props.totalAdults}
                totalKids={this.props.totalKids}
                allowKids={this.props.allowKids}
                formSubmitting={this.props.formSubmitting}
                validationErrors={this.state.validationErrors}
              />
            }
            { this.props.rsvpResponse === 'no' &&
              <NotificationInputs
                formSubmitting={this.props.formSubmitting}
                rsvpResponse={this.props.rsvpResponse}
                ref="notificationInputs"
              />
            }
            { this.props.showNotifyMarketing &&
              <div>
                <MarketingInputs
                  notifyMarketing={this.props.notifyMarketing}
                  formSubmitting={this.props.formSubmitting}
                />
              </div>
            }
            <fieldset className="rsvp-submit">
              <button
                id="rsvp-send"
                className="button-primary"
                disabled={this.props.formSubmitting}
              >
                {this.props.hasRsvpd ? 'Update RSVP' : 'Submit RSVP'}
              </button>
            </fieldset>

            <div style={{maxHeight: `${showPlusOneOptions?"200":"0"}px`}} className="plus-one-options-container">
              <PlusOneOptions/>
            </div>

          </form>
        </div>
      );
    }
    return (
      <SimpleModal
        isOpen={this.props.showModal}
        onCloseClick={this.closeModal}
        modalId="rsvp-modal"
        modalClassName={'rsvp-modal' + (window.is_mobile_site ? ' mobile' : '')}
        centered
      >
        {content}
      </SimpleModal>
    );
  }
}


class ReplyingAs extends Component {
  componentDidUpdate(prevProps) {
    if (!prevProps.editingName && this.props.editingName) {
      ReactDOM.findDOMNode(this.refs.nameInput).focus()
    }
  }

  render(){
    const allowInviteMore = window.evite_event.options.event_option_allow_invite_more;
    const placeHolder = window.user_is_registered ? "Name" : this.props.guestName;
    return (
      <div className="replying-as">
        Replying as:
        { this.props.editingName ?
          <span>
            <span className="change-name-input">
              <input
                type="text"
                maxLength="50"
                value={this.props.altGuestName}
                ref="nameInput"
                onChange={this.handleAltNameChange}
                placeholder="Name"
              />
              { window.user_is_registered &&
                <a
                  href="#"
                  onClick={this.handleCancelChangeNameClick}
                >
                  <i className="icon-cancel"></i>
                </a>
              }
              { this.props.validationErrors.guestName &&
                <span className="validation-error">
                  { this.props.validationErrors.guestName }
                </span>
              }
            </span>
            { !window.is_premium && !window.user_is_registered && allowInviteMore &&
              <a href="#" onClick={this.handleNotYouClick}>
                <small> Not you?</small>
              </a>
            }
          </span>
        :
          <span>
            <b>&nbsp;{this.props.guestName}&nbsp;</b>
            <a href="#" onClick={this.handleChangeNameClick}>
              <small>Edit</small>
            </a>
            { !window.is_premium && allowInviteMore &&
              <a href="#" onClick={this.handleNotYouClick}>
                <small> | Not you?</small>
              </a>
            }
          </span>
        }
      </div>
    )
  }

  handleAltNameChange = (e) => {
    actions.setAltGuestName(e.target.value);
  };

  handleCancelChangeNameClick = (e) => {
    e.preventDefault();
    actions.setEditingGuestName(false, "");
  };

  handleChangeNameClick = (e) => {
    e.preventDefault();
    actions.setEditingGuestName(true, this.props.guestName);
  };

  handleNotYouClick = (e) => {
    e.preventDefault();
    actions.setNotYou();
  };
}

class NameEmailInputs extends Component{
  render(){
    return (
      <fieldset className="rsvp-name-email">
        { this.props.storedGuestName &&
          <a href="#"
            onClick={ this.handleCancelNotYou }
            className="cancel-not-you"
          >
            Cancel
          </a>
        }
        <span className="input-wrap">
          <input
            type="text"
            autoComplete="off"
            placeholder="Name"
            value={this.props.guestName}
            onChange={this.handleNameChange}
            maxLength="50"
            disabled={this.props.formSubmitting}
            required
          />
          { this.props.validationErrors.guestName &&
            <span className="validation-error">
              { this.props.validationErrors.guestName }
            </span>
          }
        </span>
        <span className="input-wrap">
          <input
            type="text"
            autoComplete="off"
            placeholder="Email"
            value={ this.props.guestEmail }
            onChange={ this.handleEmailChange }
            maxLength="50"
            disabled={this.props.formSubmitting}
            required
          />
          { this.props.validationErrors.guestEmail &&
            <span className="validation-error">
              { this.props.validationErrors.guestEmail }
            </span>
          }
        </span>
      </fieldset>
    )
  };

  handleNameChange = (e) => {
    actions.setGuestName(e.target.value);
  };

  handleEmailChange = (e) => {
    actions.setGuestEmail(e.target.value.trim());
  };

  handleCancelNotYou = (e) => {
    e.preventDefault();
    actions.unsetNotYou();
  };
}

class TotalGuests extends Component {
  render() {
    const maxNumGuests = actions.getMaxAdultCount();
    if (this.props.allowKids) {
      return (
        <fieldset className="total-guests">
          <div className="total-adults">
            <input
              type="number"
              id="total-adults-input"
              min="0"
              max={maxNumGuests}
              value={this.props.totalAdults}
              onChange={this.handleTotalAdultsChange}
              onBlur={this.handleTotalAdultsFocusOut}
              disabled={this.props.formSubmitting}
              required
            />
            <label htmlFor="total-adults-input">
              Total adults
              { this.props.validationErrors.totalAdults &&
                <span className="validation-error">
                  {this.props.validationErrors.totalAdults}
                </span>
              }
              <span className="desc">
                 (including you)
              </span>
            </label>
          </div>
          <div className="total-kids">
            <input
              type="number"
              id="total-kids-input"
              min="0"
              max={maxNumGuests}
              value={this.props.totalKids}
              onChange={this.handleTotalKidsChange}
              disabled={this.props.formSubmitting}
              required
            />
            <label className="last" htmlFor="total-kids-input">
              Total kids
              { this.props.validationErrors.totalKids &&
                <span className="validation-error">
                  {this.props.validationErrors.totalKids}
                </span>
              }
            </label>
          </div>
        </fieldset>
      )
    }

    return (
      <fieldset className="total-guests">
        <input
          type="number"
          id="total-adults-input"
          min="1"
          max={maxNumGuests}
          value={this.props.totalAdults}
          onChange={this.handleTotalAdultsChange}
          onBlur={this.handleTotalAdultsFocusOut}
          disabled={this.props.formSubmitting}
          required
        />
        <label htmlFor="total-adults-input">
          Total guests
          { this.props.validationErrors.totalAdults &&
            <span className="validation-error">
              {this.props.validationErrors.totalAdults}
            </span>
          }
          <span className="desc">
             (including you)
          </span>
        </label>
      </fieldset>
    )
  }

  handleTotalAdultsChange = (e) => {
    actions.setTotalAdults(parseInt(e.target.value, 10));
  };

  handleTotalAdultsFocusOut = (e) => {
    const value = parseInt(e.target.value, 10);
    if (isNaN(value)) {
      actions.setTotalAdults(actions.getMinAdultCount());
    }
  };

  handleTotalKidsChange = (e) => {
    actions.setTotalKids(parseInt(e.target.value, 10));
  };
}


class NotificationInputs extends Component{
  constructor(props){
    super(props);

    const rsvp = window.evite_event.rsvp;
    let email_new_comments = rsvp && rsvp.notifications ? rsvp.notifications.email_new_comments : false;
    let notify_only_my_activity = rsvp && rsvp.notifications ? rsvp.notifications.notify_only_my_activity : true;

    if (!rsvp || (rsvp.response === 'undecided' && this.props.rsvpResponse === 'no')) {
      // If we are a new RSVP on the "No" state of the form then override the notification inputs
      email_new_comments = false;
      notify_only_my_activity = true;
    }

    this.state = {
      email_new_comments,
      notify_only_my_activity
    };
  }

  componentDidMount(){
    if (!utils.isMobile()) {
      $('.abbr').tooltips();
    }
  }

  render(){
    const isDisabled = this.props.formSubmitting;
    const notifyOnlyMyActivityDisabled = this.state.email_new_comments || isDisabled;
    return (
      <div>
        <fieldset>
          <small><b>Keep up to date with relevant information:</b></small>
        </fieldset>
        <fieldset>
          <input
            type="checkbox"
            id="notify-only-my-activity"
            name="something_else"
            checked={this.state.notify_only_my_activity || this.state.email_new_comments}
            onChange={this.handleEventNotifyOnlyMyActivityChanged}
            disabled={notifyOnlyMyActivityDisabled}
                />
                <label htmlFor="notify-only-my-activity">
              <span></span>
              Notify me of activity that involves me
            { !utils.isMobile() &&
            <span
              className="abbr"
              title="You will be notified when a guest replies to you, likes your post, mentions or tags you."
            >
              &nbsp;[?]
            </span>
            }
          </label>
        </fieldset>
        <fieldset>
          <input
            type="checkbox"
            id="notify-event-activity"
            name="something"
            checked={this.state.email_new_comments}
            onChange={this.handleEventActivityChanged}
            disabled={isDisabled}
          />
          <label htmlFor="notify-event-activity">
            <span></span>
            Notify me of event activity (photos, comments, and more)
            { !utils.isMobile() &&
              <span
                className="abbr"
                title="When guests comment, or upload photos"
              >
                &nbsp;[?]
              </span>
            }
          </label>
        </fieldset>
      </div>
    )
  }

  handleEventNotifyOnlyMyActivityChanged = () => {
    this.setState({
      notify_only_my_activity: !this.state.notify_only_my_activity
    })
  };

  handleEventActivityChanged = () => {
    this.setState({
      email_new_comments: !this.state.email_new_comments,
      notify_only_my_activity: this.state.notify_only_my_activity || this.state.email_new_comments,
    })
  };
}


class MarketingInputs extends Component {
  render(){
    return (
      <fieldset id="notify-marketing-wrap">
        <input
          type="checkbox"
          id="notify-marketing"
          checked={this.props.notifyMarketing}
          onChange={this.handleMarketingChanged}
          disabled={this.props.formSubmitting}
        />
        <label htmlFor="notify-marketing">
          <span></span>
          I'd like to receive party secrets, gift ideas, special offers and more.
        </label>
      </fieldset>
    )
  }

  handleMarketingChanged = () => {
    actions.setNotifyMarketing(!this.props.notifyMarketing);
  };
}

const EMAIL_SUBMIT_CHARS = [',', ' ', 'Enter'];

class PlusOneOptions extends Component {
  constructor(props) {
    super(props);
    this._justRemovedAnEmail = false;

    store.subscribe(this.handleStateChanged);
  }

  componentDidMount() {
    this.jQueryInit();
  }

  componentDidUpdate() {
    this.jQueryInit();
    this.updateErrorMessage();
  }

  render() {
    this.jQueryInit();

    let emails = actions.getPlusOneEmails();
    const handleEmailRemoveButtonClickedFunc = this.handleEmailRemoveButtonClicked;
    let emailItems = emails.map(function (email, index) {
      return <PlusOneEmailItem key={index} email={email} handleEmailRemoveButtonClicked={handleEmailRemoveButtonClickedFunc} />;
    });
    let inputClasses = "email_entry";
    let inputPlaceholderText = "Enter emails separated by commas or returns...";
    if (emails.length > 0) {
      inputClasses += " shrunken";
      inputPlaceholderText = '';
    }

    return (
        <div className="plus_one"
          onClick={this.handlePlusOneDivClicked}
        >
        <p className="plus_one_instructions">Please enter the emails of the guests you're bringing.
          <span className="optional">(optional)</span>
        { !utils.isMobile() &&
          <span className="abbr" title="This will send your guests the Party Invitation so they can interact with the event.">[?]</span>
        }
        </p>

        <div className="email_list_editor" id="id_emails_list_editor">
          <ul className="email_list_items" id="id_email_list_items">
            {emailItems}
            <input
              type="text"
              className={inputClasses}
              id="id_email_entry"
              autoComplete="off"
              placeholder={inputPlaceholderText}
              onKeyDown={this.handleEditorKeyDown}
              onChange={this.handleEditTextChanged}
              value={actions.getPlusOneEditText()}
            />
          </ul>
        </div>
        <div className="plus_one_errors" id="id_plus_one_errors">{this.getErrorMessageBasedOnValues()}</div>
      </div>
    );
  }

  jQueryInit() {
    // init tooltips on elements if needed
    let abbrElems = $('.abbr');
    for(let idx=0; idx < abbrElems.length; idx++) {
      let abbrElem = abbrElems[idx];
      if(abbrElem.hasAttribute('data-tooltip')) {
        return;
      }
      abbrElems.tooltips();
    }
  }

  addEmailFromEditorContents() {
    const errMsg = actions.addEmailFromEditorContents();
    if (errMsg) {
      setPlusOnesErrorMessage(errMsg);
    }
  }

  getEditorContents() {
    return this._getEmailEditorElement().val();
  }

  isEditorEmpty() {
    return ! Boolean(this.getEditorContents());
  }

  clearEditorContents() {
    this._getEmailEditorElement().val('');
    this._justRemovedAnEmail = false;
    actions.setPlusOneEditText('');
    this.updateErrorMessage();
  }

  handlePlusOneDivClicked = (e) => {
    this._getEmailEditorElement().focus();
  };

  handleEditorKeyDown = (e) => {
    this._justRemovedAnEmail = false;
    if (EMAIL_SUBMIT_CHARS.includes(e.key)) {
      e.preventDefault();
      this.addEmailFromEditorContents();
    } else if (e.key == 'Backspace' && this.isEditorEmpty()) {
      e.preventDefault();
      this._justRemovedAnEmail = true;
      actions.removeLastPlusOneEmail();
    } else {
      this.updateErrorMessage();
    }
  };

  handleEditTextChanged = (e) => {
    actions.setPlusOneEditText(this.getEditorContents());
  };

  handleEmailRemoveButtonClicked = (emailAddr) => {
    this._justRemovedAnEmail = true;
    actions.removePlusOneEmail(emailAddr);
  };

  handleStateChanged = () => {
    this.updateErrorMessage();
  };

  getErrorMessageBasedOnValues() {
    const adultCount = this.props.totalAdults;
    const maxNumEmails = adultCount - 1;
    const numEmailsEntered = actions.getPlusOneEmails().length;

    if (this._justRemovedAnEmail && numEmailsEntered < maxNumEmails) {
      return "Be sure to adjust your 'Total guests' count to reflect the number of guests you are RSVPing for.";
    } else if (numEmailsEntered > maxNumEmails) {
      return `A maximum of ${maxNumEmails} email address${maxNumEmails > 1 ? 'es' : ''} can be added.`;
    } else {
      return '';
    }
  }

  updateErrorMessage() {
    setPlusOnesErrorMessage(this.getErrorMessageBasedOnValues());
  }

  _getEmailEditorElement() {
    return $("#id_email_entry");
  }
}


function setPlusOnesErrorMessage(errMsg) {
  const elem = $("#id_plus_one_errors").first();
  if (! elem) {
    return;
  }
  elem.html(errMsg);
}


class PlusOneEmailItem extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return <li className="email_list_item">{this.props.email}<RemoveEmailButton onRemoveClicked={this.handleRemoveClicked} /></li>
  }

  handleRemoveClicked = (e) => {
    this.props.handleEmailRemoveButtonClicked(this.props.email);
  };
}


class RemoveEmailButton extends Component {
  render() {
    return <i className="remove_button" onClick={this.props.onRemoveClicked}>x</i>
  }
}


function mapStateToRsvpProps(state) {
  return state.rsvp;
}


TotalGuests = connect(mapStateToRsvpProps)(TotalGuests);
PlusOneOptions = connect(mapStateToRsvpProps)(PlusOneOptions);
RsvpModalForm = connect(mapStateToRsvpProps)(RsvpModalForm);

export { RsvpModalForm };
export default RsvpModalForm;



// WEBPACK FOOTER //
// ./assets/es6/view_invitation/rsvp/components/rsvp-modal-form.es6